export default "__VITE_ASSET__56a966de__"